<template>
	<div :class="['container__message', messageType]">
		<div :class="['container__message__icon', messageType]">
			<i :class="messageIcon" />
		</div>
		<div class="container__message__text">
			<div :class="['container__message__text__title', messageType]">
				{{ messageTitle }}
			</div>
			<div
				v-if="messageText"
				:class="['container__message__text__messsage', messageType]"
			>
				<p v-html="messageText" />
			</div>
			<div
				v-else-if="messageList"
				:class="['container__message__text__messsage', messageType]"
			>
				<ul style="margin-left: 1rem">
					<li
						v-for="(messageListItem, index) in messageList"
						:key="index"
					>
						{{ messageListItem }}
					</li>
				</ul>
			</div>
			<div
				v-else
				:class="['container__message__text__messsage', messageType]"
			>
				<p v-html="$t(dafaultMessages[messageType])" />
			</div>
		</div>
		<div :class="['container__message__close', messageType]">
			<a @click="closeMessage(messageId)">
				<i class="fas fa-times" />
			</a>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
	methods: {
		...mapMutations('moduleMessages', ['mutationRemoveMessage']),

		closeMessage(messageId) {
			this.mutationRemoveMessage(messageId)
		},
	},
	props: {
		messageId: String,
		messageTitle: String,
		messageText: String,
		messageList: Array,
		messageIcon: String,
		messageType: {
			type: String,
			default: 'default',
		},
	},
	computed: {
		dafaultMessages() {
			return {
				success: 'operationSuccessful',
				warning: 'operationInAttention',
				info: 'Informação', //normalmente, info deve vir com mensagem personalizada
				error: 'Erro ao realizar operação',
			}
		},
	},
}
</script>

<style scped>
.container__message {
	background-color: white;
	border: 1px solid var(--color-gray);
	border-radius: 5px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 1rem 0;
	width: 100%;
	margin-top: 1rem;
	position: relative;
	animation: anima_container__message 5s ease-in-out forwards;
}
.container__message.warning {
	background-color: var(--color-warning-background);
	border-color: var(--color-warning-title);
}
.container__message.info {
	background-color: var(--color-info-background);
	border-color: var(--color-info-title);
}
.container__message.success {
	background-color: var(--color-success-background);
	border-color: var(--color-success-title);
}
.container__message.error {
	background-color: var(--color-error-background);
	border-color: var(--color-error-title);
}

@keyframes anima_container__message {
	0% {
		opacity: 0;
	}

	10%,
	90% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}

.container__message:before {
	content: '';
	position: absolute;
	width: 0%;
	bottom: 0;
	height: 0.31rem;
	background-color: var(--color-green);
	border-end-start-radius: 5rem;
	border-end-end-radius: 5px;
	animation: anima_message_item 5s ease-in-out forwards;
}
.container__message.warning:before {
	background-color: var(--color-warning-title);
}
.container__message.info:before {
	background-color: var(--color-info-title);
}
.container__message.success:before {
	background-color: var(--color-success-title);
}
.container__message.error:before {
	background-color: var(--color-error-title);
}

@keyframes anima_message_item {
	from {
		width: 0%;
	}

	to {
		width: 100%;
	}
}

.container__message__icon {
	align-items: center;
	color: var(--color-green);
	display: flex;
	font-size: 1.5rem;
	justify-content: center;
	width: 15%;
}
.container__message__icon.warning {
	color: var(--color-warning-title);
}
.container__message__icon.info {
	color: var(--color-info-title);
}
.container__message__icon.error {
	color: var(--color-error-title);
}
.container__message__icon.success {
	color: var(--color-success-title);
}

.container__message__text {
	width: 80%;
}

.container__message__text__title {
	color: var(--color-navy-blue);
	font-weight: 700;
}
.container__message__text__title.warning {
	color: var(--color-warning-title);
}
.container__message__text__title.info {
	color: var(--color-info-title);
}
.container__message__text__title.success {
	color: var(--color-success-title);
}
.container__message__text__title.error {
	color: var(--color-error-title);
}

.container__message__text__messsage {
	color: var(--color-gray);
	font-size: 0.8rem;
}
.container__message__text__messsage.warning {
	color: var(--color-warning-message);
}
.container__message__text__messsage.info {
	color: var(--color-info-message);
}
.container__message__text__messsage.success {
	color: var(--color-success-message);
}
.container__message__text__messsage.error {
	color: var(--color-error-message);
}

.container__message__close {
	align-items: flex-start;
	color: var(--color-gray);
	display: flex;
	font-size: 0.8rem;
	justify-content: center;
	position: relative;
	width: 5%;
}

.container__message__close a {
	position: absolute;
	right: 0.93rem;
	top: -0.5rem;
	cursor: pointer;
	color: var(--color-gray);
}
.container__message__close.warning a {
	color: var(--color-warning-message);
}
.container__message__close.info a {
	color: var(--color-info-message);
}
.container__message__close.success a {
	color: var(--color-success-message);
}
.container__message__close.error a {
	color: var(--color-error-message);
}

.container__message__close a:hover {
	color: var(--color-gray-dark);
}
.container__message__close.warning a:hover {
	color: var(--color-warning-title);
}
.container__message__close.info a:hover {
	color: var(--color-info-title);
}
.container__message__close.success a:hover {
	color: var(--color-success-title);
}
.container__message__close.error a:hover {
	color: var(--color-error-title);
}

@media screen and (min-width: 576px) {
	.container__message__icon {
		width: 10%;
	}
	.container__message__text {
		width: 90%;
	}
}
</style>
